import { CopyIcon } from '@chakra-ui/icons'
import { Box, useClipboard, useColorModeValue,
   } from '@chakra-ui/react'
import React from 'react'
import { IContext, TextContext } from '../hooks/context'

const Balances = () => {
    const {address,list} = React.useContext(TextContext) as IContext
 
  const { hasCopied, onCopy } = useClipboard(address)
  const col = useColorModeValue("black","white")
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  return (
    <Box>
   
    {list.length >0 && 
    // <Draggable>
        <Box>
<Box width={["90%","90%","350px"]} margin="0 auto" maxHeight="400px" borderRadius="20px"  py="40px" background="#1a0415" border="1px solid #757373">
<Box overflowY="scroll" maxHeight="300px">
<table>
<thead>
      <tr>
        <th>Name</th>
        <th>Symbol</th>
        <th>Balance</th>
      </tr>
    </thead>
  <tbody>
  {
    list
    .filter((item:any)=>parseFloat(item.balance) > 0)
    .map((item:any,index:number)=>{
            return (
                 <tr key={index}>
                 <td>{item.tokenSymbol}</td>
                 <td>{item.tokenName}</td>
                 <td>{(numberWithCommas(parseFloat(item.balance).toFixed(2)))}</td>
               </tr>
            )
    })
  }
  </tbody>
</table>

</Box>

{/* </table> */}
{/* <TableContainer  maxHeight={["150px","150px","350px"]}  height={["150px","150px","100%"]}  width={["60%","60%","500px"]} overflowY="scroll">
  <Table variant='striped'  fontSize="10px" >
 
    <Tbody>
    {
    list
    .filter((item:any)=>parseFloat(item.balance) > 0)
    .map((item:any,index:number)=>{
            return (
                 <Tr key={index} fontSize="10px" py="2px" background={index %2 ? light: dark}>
                 <Td>{item.tokenSymbol}</Td>
                 <Td>{item.tokenName}</Td>
                 <Td>{(numberWithCommas(parseFloat(item.balance).toFixed(2)))}</Td>
               </Tr>
            )
    })
}
     
    </Tbody>
  </Table>
</TableContainer> */}
</Box>

    </Box> 
    // </Draggable>
   

    }
    </Box>
  )
}

export default Balances